<template>
    <div class="container-fluid">
        
                <h1>Catálogo Funko Pop</h1>
            
                <form>
                    <select
                    class="form-select"
                        aria-label="ordenar"
                        name="ordenar"
                        id="ordenar"
                        v-model="orden"
                        @change="ordenar(e)"
                    >
                        <option selected="selected" value=""
                        >Ordena por</option
                        >
                        <option value="menorPrecio">Menor precio</option>
                        <option value="mayorPrecio">Mayor precio</option>
                        <option value="alfabetico">Orden ABC</option>
                        <option value="masNuevo">Más nuevo</option>
                    </select>
                </form>
          
        <template v-if="datosPop">
            <div class="all-figures-pop">
                <TarjetaPop v-for="pop in datosPaginados" :key="pop.llavePop"
                    :pop="pop" :existencia="validacionCookieExistencias()"
                ></TarjetaPop>
            </div>
            <nav aria-label="Page navigation example" class="mt-5">
                <Paginacion
                    @paginaActualizada="paginaActualizada"
                    :paginaActual="paginaActual"
                    :datosPop="datosPop"
                ></Paginacion>
            </nav>
        </template>
    </div>
</template>

<script>
import { getDatabase, ref, get } from "firebase/database";
import TarjetaPop from './shared/TarjetaPop.vue';
import Paginacion from './shared/Paginacion.vue'
import moment from 'moment';

export default {
    components: { TarjetaPop, Paginacion },
    //props: ['pops'],
    data(){
        return{
            datosPop: null,
            elementosPorPagina: 20,
            datosPag: [],
            paginaActual: 1,
            orden: "",
            filtro: this.$route.params.filter,
            existencia: 0
        }
    },
    async created(){

        this.orden = this.filtro != "" ? this.orden = this.filtro : this.orden;        
        this.datosPop = await this.obtenerDatos();
        this.datosPop = this.datosPop.filter( 
            pop => this.validacionDisponibilidad(pop)[0] > 0
        );
        this.ordenar();
    },
    methods: {
        ordenar(){
            this.$router.push(
                {   
                    path: '/catalogo/'+ this.orden, 
                }
            );

            if(this.orden === "alfabetico" || this.orden === ""){
                this.datosPop =  this.datosPop.sort(function(a, b){          
                    if(a.nombre < b.nombre) { return -1; }
                    if(a.nombre > b.nombre) { return 1; }
                    return 0;
                })
            }

            if(this.orden === "menorPrecio"){
                this.datosPop =  this.datosPop.sort(function(a, b){          
                    if(a.precioPublico - a.descuentoPrecioPublico < b.precioPublico - b.descuentoPrecioPublico) { return -1; }
                    if(a.precioPublico - a.descuentoPrecioPublico > b.precioPublico - b.descuentoPrecioPublico) { return 1; }
                    return 0;
                })
            } 

            if(this.orden === "mayorPrecio"){
                this.datosPop =  this.datosPop.sort(function(a, b){          
                    if(a.precioPublico - a.descuentoPrecioPublico > b.precioPublico - b.descuentoPrecioPublico) { return -1; }
                    if(a.precioPublico - a.descuentoPrecioPublico < b.precioPublico - b.descuentoPrecioPublico) { return 1; }
                    return 0;
                })
            }
            
            if(this.orden === "masNuevo"){
                
                this.datosPop = this.datosPop.sort((a,b)=>{
                    let diaA = 0, diaB = 0;
                    let calcularDias = a => {
                        let ahora = moment(moment.utc()); 
                        return ahora.diff(a.fechaLlegada, "days", true);
                    };

                    diaA = !a.hasOwnProperty('fechaLlegada') ? 9999 : calcularDias(a);
                    diaB = !b.hasOwnProperty('fechaLlegada') ? 9999 : calcularDias(b);
                    
                    if(diaA < diaB){return -1}
                    if(diaA > diaB){return 1}
                    return 0;
                });
            }

            this.paginaActualizada(1);
    
        },
         validacionDisponibilidad(pop){
            let totalApartados = null;
            if (pop.apartados) {
                totalApartados = Object.keys(pop.apartados).reduce(
                (suma, indice) => suma + pop.apartados[indice].cantidadApartada, 0);
            }
            return [
                pop.cantidadDisponible - totalApartados ?? 0,
                totalApartados ?? 0,
            ];
        },
        ordenarPor(pops, ordenar = "nombre"){
            pops = Object.keys(pops).map((key) => pops[key]);
            if(ordenar === "nombre"){
                return pops.sort(function(a, b){          
                    if(a.nombre < b.nombre) { return -1; }
                    if(a.nombre > b.nombre) { return 1; }
                    return 0;
                })
            } 
            
        },
        async obtenerDatos() {
            const db = getDatabase();
            const dbRef = ref(db, "inventario");
            const snapshot = await get( dbRef);
            let pops = JSON.parse(JSON.stringify(snapshot));
            return this.ordenarPor(pops);
        },
       
        obtenerDatosPaginados(noPagina = 0){
            this.paginaActual = noPagina;
            this.datosPag = [];
            let paginacionInicial = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
            let paginacionFinal = (noPagina * this.elementosPorPagina);

            return this.datosPop.slice(paginacionInicial,paginacionFinal);
        },
        paginaActualizada(paginaActual){
            this.paginaActual = paginaActual;
        },
        validacionCookieExistencias(){
            function getCookie(username) {
                let nombre = username + "=";
                let split = document.cookie.split(';');
                for(var j = 0; j < split.length; j++) {
                    let char = split[j];
                    while (char.charAt(0) == ' ') {
                    char = char.substring(1);
                    }
                    if (char.indexOf(nombre) == 0) {
                    return char.substring(nombre.length, char.length);
                    }
                }
                return "";
            }

            function checkCookie() {
                let cookie = getCookie("gladysInventario");
                if(cookie == 1) return true;
                return false;
            }

            return checkCookie();
            //let existencia = getCookie
        }
    },
    computed: {
        datosPaginados(){
            return this.obtenerDatosPaginados(this.paginaActual, this.datosPop);
            //return this.datosPag;
        },
    }
}
</script>

<style scoped lang="scss">

    @function pxToRem($value) {
        $remValue: ($value / 16) + rem; 
        @return $remValue;
    }

    h1{
        margin: pxToRem(20) 0;
        font-weight: bold;
        margin-top: 0;
        margin-bottom: pxToRem(10);
    }

    .all-figures-pop{
        display: grid;
        justify-content: center;
        //grid-template-columns: repeat(auto-fill, 160px);
        grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
        gap: pxToRem(15) pxToRem(10);
        justify-content: space-evenly;
        @media (min-width: 767px){
            grid-template-columns: repeat(auto-fill, 232px);
            gap: pxToRem(30);
            justify-content: space-evenly;
            justify-content: center;
        }
    }

    form{
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin-bottom: pxToRem(20);
        select{
            width: 200px;

        }
    }

</style>